import { useRef, useState } from 'react';
import { ChatCircleDots, Info } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import { api, ApiError } from './api';

export const INTERNAL_ERROR_MESSAGE = 'Возникла ошибка. Пожалуйста, напишите об этом в поддержку. Мы сразу же это устраним.';

export function isInternalClientError(error: unknown): boolean {
  if (error instanceof ApiError) return error.status === 0 || error.status >= 500;
  return false;
}

export function userFacingErrorMessage(error: unknown): string {
  if (isInternalClientError(error)) return INTERNAL_ERROR_MESSAGE;
  if (error instanceof Error) return error.message;
  return INTERNAL_ERROR_MESSAGE;
}

export function ErrorNotice({
  error,
  variant = 'notice',
  showSupportAction = true,
}: {
  error: unknown;
  variant?: 'notice' | 'banner';
  showSupportAction?: boolean;
}) {
  const navigate = useNavigate();
  const eventId = useRef(crypto.randomUUID());
  const [reporting, setReporting] = useState(false);
  if (!error) return null;

  const internal = isInternalClientError(error);
  const apiError = error instanceof ApiError ? error : null;
  const openSupport = async () => {
    if (reporting) return;
    setReporting(true);
    try {
      await api.post('/v1/support/error-events', {
        eventId: eventId.current,
        code: apiError?.code ?? 'CLIENT_RUNTIME_ERROR',
        status: apiError?.status ?? 0,
        path: window.location.pathname,
        endpoint: apiError?.requestPath.split('?', 1)[0] ?? null,
      });
    } catch {
      // Support must remain reachable even when telemetry delivery fails.
    } finally {
      navigate('/support?reported=1');
    }
  };

  return <div className={variant === 'banner' ? 'error-banner' : 'notice notice-error error-notice'} role="alert">
    <span className="error-notice-message"><Info weight="fill" />{userFacingErrorMessage(error)}</span>
    {internal && showSupportAction && (
      <button type="button" className="error-support-action" onClick={() => void openSupport()} disabled={reporting}>
        <ChatCircleDots /> {reporting ? 'Открываем поддержку...' : 'Написать в поддержку'}
      </button>
    )}
  </div>;
}
